import React from 'react';
import { ModalProps } from  '../../_config/interfaces/interfaces';

const InfoModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50 w-full h-full">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full">
        {/* Modal Content */}
        <div className="flex flex-col items-center">
          {/* Image */}
          <img
            src="/assets/images/no-profile.jpg" // Replace with your image URL
            alt="Info Image"
            className="mb-4 w-32 h-32 object-cover rounded-full"
          />

          {/* Heading */}
          <h3 className="text-2xl font-semibold text-center text-gray-800 mb-2">
            Step 1
          </h3>

          {/* Text Content */}
          <p className="text-lg text-gray-700 text-center">
            This is an informational modal. You can add more content here to explain
            anything you like. The width of this modal is larger now, and it can contain
            more detailed information.
          </p>

          
        </div>
        <div className="flex flex-col items-center">
          {/* Image */}
          <img
            src="/assets/images/no-profile.jpg" // Replace with your image URL
            alt="Info Image"
            className="mb-4 w-32 h-32 object-cover rounded-full"
          />

          {/* Heading */}
          <h3 className="text-2xl font-semibold text-center text-gray-800 mb-2">
            Step 2
          </h3>

          {/* Text Content */}
          <p className="text-lg text-gray-700 text-center">
            This is an informational modal. You can add more content here to explain
            anything you like. The width of this modal is larger now, and it can contain
            more detailed information.
          </p>

          {/* Close Button */}
          <div className="mt-4 flex justify-end w-full">
            <button
              onClick={onClose}
              className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
